import { Routes } from '@angular/router';

import { AuthenticatedUserComponent } from './authenticated-user/authenticated-user.component';

import { HomeComponent } from './home/home.component';
import { SignInComponent } from '../fw/users/sign-in.component';
import { SettingsCashregComponent } from './settings/settings-cashreg/settings-cashreg.component';
import { SettingsBaseComponent } from './settings/settings-base/settings-base.component';
import {SettingsEventActionColorComponent} from "./settings/settings-eventaction/settings-eventaction-color.component";
import {SettingsEventActionPermComponent} from "./settings/settings-eventaction/settings-eventaction-perm.component";
import {EmployeeListComponent} from "./employees/employee-details/employee-list.component";
import {SettingsSecurityComponent} from "./settings/settings-security/settings-security.component";
import {SettingsPlannerComponent} from "./settings/settings-planner/settings-planner.component";
import {EmployeeComponent} from "./employees/employee-details/employee.component";
import {StockOverviewComponent} from "./stock/stock-overview/stock-overview.component";
import {StockInventoryComponent} from "./stock/stock-inventory/stock-inventory.component";
import {CashregWeekComponent} from "./administration/cashreg-week/cashreg-week.component";
import {DepositComponent} from "./administration/deposit/deposit.component";
import {CustomerSearchComponent} from "./customers/customer-search/customer-search.component";
import {CustomerComponent} from "./customers/customer/customer.component";
import {ManagementQuickviewComponent} from "./management/quickview/management-quickview.component";
import {CustomerOverviewComponent} from "./customers/customer-overview/customer-overview.component";
import {CashbookComponent} from "./administration/cashbook/cashbook.component";
import {TreatmentInfoComponent} from "./management/treatment-info/treatment-info.component";
import {ArticleInfoComponent} from "./management/article-info/article-info.component";
import {ManagementCustomerInfoComponent} from "./management/customer-info/management-customer-info.component";
import {BranchesListComponent} from "./branches/branches-list/branches-list.component";
import {ManagementSalesGoalComponent} from "./management/sales-goal/management-sales-goal.component";
import {CashregDayComponent} from "./administration/cashreg-day/cashreg-day.component";
import {EmployeeInfoComponent} from "./management/employee-info/employee-info.component";
import {MarketingInfoComponent} from "./marketing/marketing-info/marketing-info.component";
import {EmployeeHouroverviewComponent} from "./employees/employee-houroverview/employee-houroverview.component";
import {AuthGuard} from "../fw/services/auth-guard.service";
import {UsedGiftcertificatesComponent} from "./administration/used-giftcertificates/used-giftcertificates.component";
import {MailingComponent} from "./marketing/mailing/mailing.component";
import {CustomerSatisfactionSurveyComponent} from "./marketing/customer-satisfaction-survey/customer-satisfaction-survey.component";

export const appRoutes: Routes = [
    { path: 'login', component: SignInComponent },
    { path: 'auth', component: AuthenticatedUserComponent, canActivate: [AuthGuard],
        children: [
            { path: '', canActivateChild: [AuthGuard],
                children: [
                    { path: '', redirectTo: 'home', pathMatch: 'full' },
                    { path: 'home', component: HomeComponent },
                    { path: 'customer-search', component: CustomerSearchComponent },
                    { path: 'customer-overview', component: CustomerOverviewComponent },
                    { path: 'customer/:id', component: CustomerComponent },
                    { path: 'employee-list', component: EmployeeListComponent },
                    { path: 'employee/:id', component: EmployeeComponent },
                    { path: 'stock-overview', component: StockOverviewComponent },
                    { path: 'stock-inventory', component: StockInventoryComponent },
                    { path: 'settings-cashreg', component: SettingsCashregComponent },
                    { path: 'settings-base', component: SettingsBaseComponent },
                    { path: 'settings-planner', component: SettingsPlannerComponent },
                    { path: 'settings-security', component: SettingsSecurityComponent },
                    { path: 'settings-eventaction-color', component: SettingsEventActionColorComponent },
                    { path: 'settings-eventaction-perm', component: SettingsEventActionPermComponent },
                    { path: 'administration-cashreg-week', component: CashregWeekComponent },
                    { path: 'administration-cashreg-day', component: CashregDayComponent },
                    { path: 'administration-cashbook', component: CashbookComponent },
                    { path: 'administration-deposit', component: DepositComponent },
                    { path: 'administration-vouchers', component: UsedGiftcertificatesComponent },
                    { path: 'management-quickview', component: ManagementQuickviewComponent },
                    { path: 'management-sales-goal', component: ManagementSalesGoalComponent },
                    { path: 'management-treatment-info', component: TreatmentInfoComponent },
                    { path: 'management-article-info', component: ArticleInfoComponent },
                    { path: 'management-customer-info', component: ManagementCustomerInfoComponent },
                    { path: 'management-employee-info', component: EmployeeInfoComponent },
                    { path: 'marketing-info', component: MarketingInfoComponent },
                    { path: 'mailing', component: MailingComponent },
                    { path: 'customer-satisfaction-survey', component: CustomerSatisfactionSurveyComponent },
                    { path: 'branches-list', component: BranchesListComponent },
                    { path: 'employee-hour-oveview', component: EmployeeHouroverviewComponent }
                ]
            }
        ]
    },
    { path: '', component: SignInComponent },
    { path: '**', component: SignInComponent }
];



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/app.routing.ts